import { EXPERIENCE } from "../data/constants";

const SHOWN = 5;   // bullets visible before the toggle

function Points({ items }) {
  return (
    <ul style={{ listStyle: "none", marginTop: 14, display: "flex", flexDirection: "column", gap: 9 }}>
      {items.map((p) => (
        <li key={p} style={{ fontSize: 11.5, lineHeight: 1.7, color: "var(--fg-dim)", display: "flex", gap: 9 }}>
          <span className="t-com" aria-hidden="true">—</span>
          <span>{p}</span>
        </li>
      ))}
    </ul>
  );
}

export default function Experience() {
  return (
    <section id="experience" className="sec">
      <p className="sec-marker reveal">{"// experience"}</p>

      {EXPERIENCE.map((e, i) => (
        <article className={`panel reveal d${i + 1}`} key={`${e.company}-${e.role}`}
                 style={{ padding: 22, marginTop: i ? 14 : 0 }}>
          <div style={{
            display: "flex", alignItems: "baseline", justifyContent: "space-between",
            gap: 12, flexWrap: "wrap",
          }}>
            <h3 className="h3">{e.role}</h3>
            <span className="row-year">{e.period}</span>
          </div>

          <p style={{ fontSize: 11.5, color: "var(--fg-mute)", marginTop: 6 }}>
            {e.company} · {e.location}
          </p>

          <Points items={e.points.slice(0, SHOWN)} />

          {e.points.length > SHOWN && (
            /* <details> gives the toggle, keyboard support and aria state for free. */
            <details className="more">
              <summary>{e.points.length - SHOWN} more</summary>
              <Points items={e.points.slice(SHOWN)} />
            </details>
          )}

          {e.tech?.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginTop: 16 }}>
              {e.tech.map((t) => <span key={t} className="chip">{t}</span>)}
            </div>
          )}
        </article>
      ))}
    </section>
  );
}
